const IMG_CDN_HOST = 'https://shared-https.ydstatic.com/ke/icode/website/images/csl/'
const CSL_HOST = process.env.NEXT_PUBLIC_CSL_HOST

export default [
  {
    type: '艺术',
    games: [
      {
        name: '小画家',
        link: `${CSL_HOST}artist`,
        image: `${IMG_CDN_HOST}art1.png`,
        desc: '为画而生，画笔的魔力现在由你主宰'
      },
      {
        name: '安娜公主',
        link: `${CSL_HOST}anna`,
        image: `${IMG_CDN_HOST}art2.png`,
        desc: '冰雪世界，地上的足印是一幅美丽的图画'
      },
      {
        name: '爱莎公主',
        link: `${CSL_HOST}elsa`,
        image: `${IMG_CDN_HOST}art3.png`,
        desc: '舞蹈公主，绚丽的舞步是创作的魔法棒'
      },
    ]
  },
  {
    type: '游戏',
    games: [
      {
        name: '飞翔的小鸟',
        link: `${CSL_HOST}flappy`,
        image: `${IMG_CDN_HOST}game1.png`,
        desc: '小鸟起飞，游戏规则正在等你改写'
      },
      {
        name: '我的篮球场',
        link: `${CSL_HOST}basketball`,
        image: `${IMG_CDN_HOST}game2.png`,
        desc: '灌篮高手，我的篮球场我做主'
      },
      {
        name: '运动场',
        link: `${CSL_HOST}sports`,
        image: `${IMG_CDN_HOST}game3.png`,
        desc: '挚爱运动，我是运动场高手'
      },
      {
        name: '小小钢琴家',
        link: `${CSL_HOST}piano`,
        image: `${IMG_CDN_HOST}piano.png`,
        desc: '跳跃的音符，美妙的旋律'
      },
      {
        name: '飞行者',
        link: `${CSL_HOST}aviator`,
        image: `${IMG_CDN_HOST}aviator.png`,
        desc: '飞行达人，在太空中穿越障碍'
      },
      {
        name: '小兔子',
        link: `${CSL_HOST}rabbit`,
        image: `${IMG_CDN_HOST}rabbit.png`,
        desc: '快速奔跑，小心后面的大灰狼'
      },
      {
        name: '海洋保卫者',
        link: `${CSL_HOST}fish`,
        image: `${IMG_CDN_HOST}fish.png`,
        desc: '海洋小卫士，清理海洋垃圾'
      },
    ]
  },
  {
    type: 'MineCraft',
    games: [
      {
        name: '英雄归来',
        link: `${CSL_HOST}minecraft_hero`,
        image: `${IMG_CDN_HOST}minecraft1.png`,
        desc: '我是英雄，但我会陪你一起闯天下'
      },
      {
        name: '造物主',
        link: `${CSL_HOST}minecraft_designer`,
        image: `${IMG_CDN_HOST}minecraft2.png`,
        desc: '造物之主，开创属于自己的大世界'
      },
      {
        name: '大冒险',
        link: `${CSL_HOST}minecraft_adventurer`,
        image: `${IMG_CDN_HOST}minecraft3.png`,
        desc: '我爱冒险，在冒险的旅途中收获快乐和成长'
      },
    ]
  },
  {
    type: '故事',
    games: [
      {
        name: '星球大战',
        link: `${CSL_HOST}starwars`,
        image: `${IMG_CDN_HOST}story2.png`,
        desc: '我爱机器人，快来跟我一起探索宇宙吧'
      },
      {
        name: '冰河世纪',
        link: `${CSL_HOST}iceage`,
        image: `${IMG_CDN_HOST}story3.png`,
        desc: '冰雪融化，快来编写你的冰川故事吧'
      },
      {
        name: '游戏创作',
        link: `${CSL_HOST}playlab`,
        image: `${IMG_CDN_HOST}story5.png`,
        desc: '变身导演，快来指挥你的角色编译剧本吧'
      },
    ]
  }
]